import React from 'react';
import { Mail, MapPin, Phone, Trash2 } from 'lucide-react';
interface FooterProps {
  onReserve: () => void;
}
export function Footer({
  onReserve
}: FooterProps) {
  return <footer className="w-full border-t border-border bg-card" data-id="element-162">
      <div className="container py-12" data-id="element-163">
        <div className="grid gap-8 md:grid-cols-4" data-id="element-164">
          <div className="md:col-span-2" data-id="element-165">
            <div className="flex items-center gap-2" data-id="element-166">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground" data-id="element-167">
                <Trash2 className="h-5 w-5" data-id="element-168" />
              </span>
              <span className="text-base font-semibold" data-id="element-169">
                Greeneway Solutions
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm text-muted-foreground" data-id="element-170">
              Simple, fair, and reliable dumpster rentals for homeowners and
              contractors across the greater metro area.
            </p>
          </div>

          <div data-id="element-171">
            <h4 className="text-sm font-semibold text-foreground" data-id="element-172">Company</h4>
            <ul className="mt-4 space-y-2 text-sm text-muted-foreground" data-id="element-173">
              <li data-id="element-174">
                <a href="#sizes" className="hover:text-foreground" data-id="element-175">
                  Sizes & Pricing
                </a>
              </li>
              <li data-id="element-176">
                <a href="#how-it-works" className="hover:text-foreground" data-id="element-177">
                  How It Works
                </a>
              </li>
              <li data-id="element-178">
                <a href="#why-us" className="hover:text-foreground" data-id="element-179">
                  Why Greeneway
                </a>
              </li>
              <li data-id="element-180">
                <a href="#faq" className="hover:text-foreground" data-id="element-181">
                  FAQ
                </a>
              </li>
              <li data-id="element-182">
                <button type="button" onClick={onReserve} className="hover:text-foreground" data-id="element-183">
                  Reserve online
                </button>
              </li>
            </ul>
          </div>

          <div data-id="element-184">
            <h4 className="text-sm font-semibold text-foreground" data-id="element-185">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm text-muted-foreground" data-id="element-186">
              <li className="flex items-center gap-2" data-id="element-187">
                <Phone className="h-4 w-4 text-primary" data-id="element-188" />
                <a href="tel:+15551234567" className="hover:text-foreground" data-id="element-189">
                  (555) 123-4567
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-190">
                <Mail className="h-4 w-4 text-primary" data-id="element-191" />
                <a href="mailto:hello@greeneway.com" className="hover:text-foreground" data-id="element-192">
                  hello@greeneway.com
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-193">
                <MapPin className="mt-0.5 h-4 w-4 text-primary" data-id="element-194" />
                Serving the greater metro area
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-2 border-t border-border pt-6 text-sm text-muted-foreground sm:flex-row" data-id="element-195">
          <p data-id="element-196">
            © {new Date().getFullYear()} Greeneway Solutions. All rights
            reserved.
          </p>
          <p data-id="element-197">Licensed & insured local haulers.</p>
        </div>
      </div>
    </footer>;
}